module.exports = __webpack_public_path__ + "img/010025.e0eb52fb.png";